export default __webpack_public_path__ + "static/media/news2.29820070.png";